import { Divider, Typography } from '@fullscreendigital/carrefour-dex-fe'
import { Container, Grid, Paper } from '@mui/material'
import { getInProgressInventoriedSeals } from 'components/shop-reception/mobile/api'
import { TitleHeader } from 'components/shop-reception/mobile/Common/TitleHeader'
import { getReturoId, getReturoMaterialLabel } from 'components/shop-reception/mobile/helpers'
import { ReturoSeal } from 'components/shop-reception/mobile/interfaces'
import { useNotification } from 'hooks'
import s from './InProgressSeals.modules.scss'
import { useNavigate } from 'react-router-dom'
import { URLS } from 'components/shop-reception/mobile/constants'
import { getShopReceptionShops } from 'components/Layout/api'
import { useMemo } from 'react'

const InProgressSeals = () => {
  const { showNotification } = useNotification()

  const navigate = useNavigate()

  const { data: seals, isLoading } = getInProgressInventoriedSeals(showNotification)

  const goToSealDetails = (seal: ReturoSeal) => {
    const { sealCode, materialType } = seal
    navigate(
      `${URLS.AUTH_RETURO_SCAN_SEALS}?fromInventory=true&sealCode=${sealCode}&materialType=${materialType}`
    )
  }

  const { data: shops } = getShopReceptionShops(showNotification, true)

  const idReturo = useMemo(() => getReturoId(shops), [shops])

  return (
    <Container maxWidth="xs" className={s.sealsContainer}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TitleHeader title={`ID Returo: ${idReturo}`} />
        </Grid>
        <Grid item xs={12}>
          <Divider component="div" />
        </Grid>
        {seals?.length ? (
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {seals?.map((item: ReturoSeal) => (
                <Grid item xs={12} key={item.id}>
                  <Paper
                    elevation={3}
                    className={s.sealContainer}
                    onClick={() => goToSealDetails(item)}
                  >
                    <Typography variant="medium" component="p">
                      {item.sealCode} {getReturoMaterialLabel(item.materialType)}
                    </Typography>
                    <Typography variant="medium" component="p">
                      {item.createdBy}
                    </Typography>
                    <Typography variant="medium" component="p">
                      {item.created}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>
        ) : !isLoading ? (
          <Grid item xs={12}>
            Nu există sigilii inventariate.
          </Grid>
        ) : null}
      </Grid>
    </Container>
  )
}

export default InProgressSeals
